import { Affix, Card, Col, Row, Statistic } from "antd";
import React from "react";
import { DislikeOutlined, LikeOutlined, WarningOutlined } from "@ant-design/icons";
import { useCurrency } from "../../context/CurrencyContext";

export default function DealInsights({ dataSource, minFTEWarning }: { dataSource?: any, minFTEWarning?: boolean }) {
  const { dealCurrency, currencySymbol } = useCurrency();
  return (
    <div>
      {dataSource && dataSource.length > 0 && (
        <Affix>
          <Card
            hoverable
            style={{ marginBottom: "16px", backgroundColor: "#c3e2ff"}}
            styles={{body: {padding: '0', paddingBottom: '8px', paddingTop: '8px'}}}
          >
            <Row gutter={16}>
            <Col span={1} />
              <Col span={5}>
                <Statistic
                  title="Net Project Revenue"
                  value={dataSource[0]["Net Project Price"]}
                  style={{ textAlign: "center" }}
                  prefix={`${currencySymbol}`}
                  valueStyle={{ color: "#1a2536" }}
                />
              </Col>
              <Col span={5}>
                <Statistic
                  title="Projected Client Margin"
                  style={{ textAlign: "center" }}
                  value={dataSource[0]["Projected Client Margin %"]}
                />
              </Col>

              <Col span={5}>
                <Statistic
                  title="Target Client Margin"
                  style={{ textAlign: "center" }}
                  value={dataSource[0]["Target Client Margin %"]}
                />
              </Col>

              <Col span={4}>
                <Statistic
                  title="Variance"
                  style={{ textAlign: "center" }}
                  valueStyle={{
                    color: `${
                      dataSource[0]["Variance to Target Margin %"][0] == "-"
                        ? "#cf1322"
                        : "#3f8600"
                    }`,
                  }}
                  value={dataSource[0]["Variance to Target Margin %"]}
                />
              </Col>
              <Col 
                span={4} 
                style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                onClick={() => {
                  const resourceSection = document.getElementById('resource-allocation-section');
                  if (resourceSection) {
                    resourceSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
              >
                <Statistic
                  title="Resource Allocation"
                  valueStyle={{textAlign: "center"}}
                  valueRender={()=>(
                    minFTEWarning ? 
                  <DislikeOutlined style={{ color: "#cf1322", fontSize: "24px", marginRight: "8px" }} />
                  : <LikeOutlined style={{ color: "#3f8600", fontSize: "24px", marginRight: "8px" }} />)}                
                />
              </Col>
            </Row>
          </Card>
        </Affix>
      )}
    </div>
  );
}
